module.exports = __webpack_public_path__ + "img/office2.b57d6529.jpg";